// extracted by mini-css-extract-plugin
export default {"msg_container":"Nga","message":"Oga","show":"Pga","fromRD":"Qga","fromCustomer":"Rga","note":"Sga","loading":"Tga","image":"Uga","initials":"Vga","input_wrapper":"Wga","input":"Xga"};
    if(module.hot) {
      // 1738064244464
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  